// extracted by mini-css-extract-plugin
export default {"reviewsList":"ReviewsList_reviewsList__MzOw+"};